module.exports = __webpack_public_path__ + "img/product-wiper-modal.21c22177.png";